import React from 'react';
import { connect } from 'react-redux';
import { createPureComponent } from 'module/Common';
import { MenuAction, MenuSelector } from 'module/Redux/Menu';
import { MenuTopBar } from './TopBar';
import { MenuWrapper } from './MenuWrapper';
import { MountedStateProvider, Sizes, WindowSizeConsumer } from 'module/View/Common';
import { ReduxCompatibleDispatch } from 'lib/redux-stabilizer';
import { State } from 'module/Redux';

type StateProps = {
  open: boolean;
};

const mapStateToProps = (s: State): StateProps => ({
  open: MenuSelector.isOpen(s),
});

type DispatchProps = {
  toggle: () => void;
};

const mapDispatchToProps = (dispatch: ReduxCompatibleDispatch): DispatchProps => ({
  toggle: () => dispatch(MenuAction.toggleOpen()),
});

type OwnProps = {
  adminBarHeight: number;
};

type Props = OwnProps & StateProps & DispatchProps;

const MenuComp = createPureComponent<Props>('Menu', ({ adminBarHeight, open, toggle }) => {
  return (
    <MountedStateProvider delay={500}>
      {mounted => (
        <WindowSizeConsumer>
          {windowSize => (
            <>
              {Sizes.isMenuTopBarVisible(windowSize.width) && (
                <MenuTopBar windowWidth={windowSize.width} adminBarHeight={adminBarHeight} />
              )}
              <MenuWrapper
                adminBarHeight={adminBarHeight}
                windowWidth={windowSize.width}
                windowHeight={windowSize.height}
                open={open}
                toggle={toggle}
                mounted={mounted}
              />
            </>
          )}
        </WindowSizeConsumer>
      )}
    </MountedStateProvider>
  );
});

export const Menu = connect(mapStateToProps, mapDispatchToProps)(MenuComp);



// WEBPACK FOOTER //
// ./src/module/View/Menu/Menu.tsx